
import { Enums } from '../common/enums'

import { ICopyable, IJsonSerializable, IOpData } from '../util/interfaces'

import { OpDataType } from '../core/op-data-type'


export class OpConsumerData implements IOpData, ICopyable<OpConsumerData> {

    // #region Properties

    public idConsumerData: number
    public idConsumer: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // #endregion


    // #region NavigationProperties

    public dataType: OpDataType

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpConsumerData) {
            this.copy(<OpConsumerData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IOpData implementation

    public get idData() { return this.idConsumerData }
    public set idData(idData: number) { this.idConsumerData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // #endregion

    public toString() {
        return "ConsumerData [" + this.idData + "]"
    }


    // #region IJsonSerializable

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idConsumerData = opObj.ID_CONSUMER_DATA
            this.idConsumer = opObj.ID_CONSUMER
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
        } else {
            this.idConsumerData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_CONSUMER_DATA: this.idConsumerData,
            ID_CONSUMER: this.idConsumer,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    // #endregion


    public static fromIOpData(data: IOpData): OpConsumerData {
        const newData: OpConsumerData = new OpConsumerData(null)

        newData.idConsumerData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConsumerData {
        const consumerData: OpConsumerData = new OpConsumerData(null)

        consumerData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerData
    }

    public copy(source: OpConsumerData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.dataType = source.dataType != null ? source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data list
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idConsumerData = source.idConsumerData
        this.idConsumer = source.idConsumer
        this.idDataType = source.idDataType
        this.indexNbr = source.indexNbr
        this.value = source.value

        this.opState = source.opState
    }

    // # endregion
}